/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimExecution } from './TimExecution';
import {
    TimExecutionFromJSON,
    TimExecutionFromJSONTyped,
    TimExecutionToJSON,
} from './TimExecution';

/**
 * 
 * @export
 * @interface GetTimExecution200Response
 */
export interface GetTimExecution200Response {
    /**
     * 
     * @type {TimExecution}
     * @memberof GetTimExecution200Response
     */
    data?: TimExecution;
}

/**
 * Check if a given object implements the GetTimExecution200Response interface.
 */
export function instanceOfGetTimExecution200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetTimExecution200ResponseFromJSON(json: any): GetTimExecution200Response {
    return GetTimExecution200ResponseFromJSONTyped(json, false);
}

export function GetTimExecution200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTimExecution200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : TimExecutionFromJSON(json['data']),
    };
}

export function GetTimExecution200ResponseToJSON(value?: GetTimExecution200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TimExecutionToJSON(value.data),
    };
}

